import Api from "./Api";
import store from "../state/store";

export default {
  getAll(params) {
    const queryParams = {
      filterBy: params && params.finalFilterObject ? params.finalFilterObject : {},
      orderBy: params && params.sortObject ? params.sortObject : { sortField: null },
      limit: params && params.limit ? params && params.limit : 10,
      page: params && params.page ? params && params.page : 1,
    }
    if (params && params.isExporting) queryParams.isExporting = true;
    return Api().get(
      `/visit_list/${store.getters["authfack/currentEntity"].id}`,
      {
        params: queryParams,
      }
    );
  },
  getCounts() {
    return Api().get(
      `/dashboard/${store.getters["authfack/currentEntity"].id}`
    );
  },
  getScanDatatypes() {
    return Api().get(`/sacn_data_type`);
  },
  getScanDatatypesForDashboard() {
    return Api().get(`/sacn_data_type?type=visit`);
  },
  getInputTypes() {
    return Api().get(`/input_method`);
  },
  getAreas() {
    return Api().get(`/areas/${store.getters["authfack/currentEntity"].id}`);
  },
  getKiosks() {
    return Api().get(`/kiosk/${store.getters["authfack/currentEntity"].id}`);
  },
  getDevices() {
    return Api().get(`/devices/${store.getters["authfack/currentEntity"].id}`);
  },
  async getUserTypes() {
    return await Api().get(
      `/user-types/list/${store.getters["authfack/currentEntity"].id}`
    );
  },

  getDashboardData() {
    return Api().get(`/dashboard/${store.getters["authfack/currentEntity"].id}`);
  },
  scanAction(visit) {
    return Api().post(`/user_action`, { visit });
  },
  dashboardAction(params) {
    return Api().post(`/checkin_users`, params);
  },
  checkInUserAction(params) {
    return Api().post('user_visiting', params);
  },
  addVisitNotes(params) {
    return Api().put(`/visits/notes`, params);
  },
  getUsersDataMassAction(params) {
    return Api().post("/mass-action-signin", params);
  },
  massActionCheckInUsers(params) {
    return Api().post("mass-action-apply-signin", params)
  },
  massActionSignInErrors(params) {
    return Api().post("mass-action-signin/errors", params)
  },
  getScansOfVisit(visitId) {
    return Api().get(`/scans/${visitId}`)
  },
  getCustomFieldsOfScan(scanId) {
    console.log('scanId', scanId);
    return Api().get(`/section/custom_field/d84bac5d-f3ae-4afe-b38c-4a803aaa5abe/list/0cd76b49-ee59-46a4-bc75-36b45f93bde6`)
  },
  getHistoryData() {
    return Api().get(`/get_history_data_grid/${store.getters["authfack/currentEntity"].id}`);
  },
};
